import { lazy } from "react";
import type { ComponentType } from "react";

const RELOADED_KEY = "lazyPage.reloadedAt";

/**
 * React.lazy for a route page that survives a deploy. index.html is served
 * no-store but the hashed chunks of the previous build are gone from the new
 * image, so a tab opened before the deploy fails to load a page it has not
 * visited yet. Reload once to pick up the new index.html; a second failure
 * within a minute is a real error and reaches the error boundary.
 */
export function lazyPage<T extends ComponentType<any>>(load: () => Promise<{ default: T }>) {
  return lazy(() =>
    load().catch((error) => {
      let last = 0;
      try {
        last = Number(sessionStorage.getItem(RELOADED_KEY)) || 0;
      } catch {
        // storage blocked: fall through to the error boundary
        throw error;
      }
      if (Date.now() - last > 60_000) {
        sessionStorage.setItem(RELOADED_KEY, String(Date.now()));
        window.location.reload();
        // Keep Suspense waiting while the page reloads.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }),
  );
}
